module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-greenery-4-35e1330010f66ff38c7bfd2a91d4fe5c.webp";